import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

const name = 'createApplicationInfo';
const initialState = createInitialState();

function createInitialState() {
    return {
        done: false,
        error: false,
        spinner: false,
        createApplicationInfo: null,
    };
}

    
export const createApplicationInfo = createAsyncThunk('createApplicationInfo', async ({ iosAppVersion,androidAppVersion,iosForceUpdate, androidForceUpdate }, { rejectWithValue }) => {
    try {
        const response = await api.post('/super/api/application-info/create', { iosAppVersion,androidAppVersion,iosForceUpdate, androidForceUpdate });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const createApplicationInfoSlice = createSlice({
    name: name,
    initialState,
    reducers: {
        resetCreateApplicationInfo: state => {
            state.done = false;
            state.error = false;
            state.spinner = false;
            state.createApplicationInfo = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(createApplicationInfo.pending, state => {
                state.spinner = true;
                state.error = false;
            })
            .addCase(createApplicationInfo.fulfilled, (state, action) => {
                state.done = true;
                state.spinner = false;
                state.error = false;
                state.createApplicationInfo = action.payload;
            })
            .addCase(createApplicationInfo.rejected, (state, action) => {
                state.done = false;
                state.spinner = false;
                state.error = action.payload;
            });
    },
});

export const { resetCreateApplicationInfo } = createApplicationInfoSlice.actions;
export const createApplicationInfoReducer = createApplicationInfoSlice.reducer;
